type ItemType = {
  id: number
  name: string
  imageSrc: string
}

export const mapItemsToAvailableStatuses = <T extends ItemType>(
  currStatus: number,
  items: T[],
) => {
  switch (currStatus) {
    case 1:
    case 7:
      return items.filter((el) => [2, 10].includes(el.id))
    case 2:
      return items.filter((el) => [1, 10].includes(el.id))
    case 4:
      return items.filter((el) => [1, 10].includes(el.id))
    case 5:
    case 6:
    case 9:
      return items.filter((el) => [10].includes(el.id))
    case 11:
      return items.filter((el) => [2, 7, 10].includes(el.id))

    default:
      return items
  }
}
